import styled from '@emotion/styled';

import Image from 'components/global/Image';

export const Card = styled.div`
	background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : '#ffffff')};
	border-radius: 10px;
	box-shadow: var(--container-box-shadow);
	width: 100%;

	.grayScale {
		filter: grayscale(100%);
	}
	.passive-stage {
		width: 100%;
		position: relative;
		z-index: 1;
		max-width: 65rem;
	}
	.lottie-first {
		position: absolute;
		width: 23% !important;
		left: -3%;
		top: 41%;
		z-index: 2;
	}
	.lottie-second {
		position: absolute;
		width: 13% !important;
		left: 23.5%;
		top: 2%;
		z-index: 2;
	}
	.lottie-third {
		position: absolute;
		width: 12% !important;
		left: 64%;
		top: 1%;
		z-index: 2;
	}
	.lottie-fourth {
		position: absolute;
		width: 15% !important;
		left: 83.6%;
		top: 40%;
		z-index: 2;
	}
`;

export const StatusContainer = styled.div`
	padding: 10px;
	text-align: center;
	border-radius: calc(0.35rem - 1px) calc(0.35rem - 1px) 0 0;
	background: ${({ headerBackgroundColor }) => (headerBackgroundColor ? `${headerBackgroundColor}` : '#2ecc71')};
	border-radius: 5px;
`;

export const Triangle = styled.div`
	width: 0;
	height: 0;
	border: 15px solid transparent;
	border-top: 0;
	border-bottom: 20px solid
		${({ headerBackgroundColor }) => (headerBackgroundColor ? `${headerBackgroundColor}` : '#2ecc71')};

	margin: auto;
	margin-top: 2rem;
	margin-bottom: -10px;
`;

export const TrackingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 3rem;
`;

export const TrackingContent = styled.div`
	padding: var(--padding-4);
	padding-left: var(--padding-5);
	div {
		padding: 5px 0;
	}
`;

export const TrackingImage = styled(Image)`
	border: 0;
	width: 100%;
	height: 100%;
`;
